const jwt_customizer = {
    general: 'An error occurred while customizing the token claims. Please try again later.',
    can_not_create_for_admin_tenant: 'Cannot create a token customizer for the admin tenant.',
};
export default Object.freeze(jwt_customizer);
